// Specialized emoji data for colleges
// This data provides visual icons and descriptions for college characteristics
// Used in both the Explore section and individual college profiles

export const collegeEmojiData = {
  // Ivy League & Elite Private
  'Harvard University': {
    programs: { emoji: '🏛️', title: 'Academic Excellence', desc: 'World-renowned Law, Medicine, Business programs' },
    vibe: { emoji: '📚', title: 'Crimson Pride', desc: 'Historic campus with intellectual tradition' },
    feature: { emoji: '👑', title: 'Elite Network', desc: 'Unparalleled alumni connections worldwide' }
  },
  'Yale University': {
    programs: { emoji: '⚖️', title: 'Liberal Arts Leader', desc: 'Exceptional Law, Medicine, Drama with renowned Yale Law' },
    vibe: { emoji: '🏰', title: 'Gothic Grandeur', desc: 'Residential college system fostering intellectual communities' },
    feature: { emoji: '🎭', title: 'Arts & Culture Hub', desc: 'World-class museums and theaters in New Haven' }
  },
  'Princeton University': {
    programs: { emoji: '📈', title: 'Economics Excellence', desc: 'Top Economics, Public Policy, Engineering programs' },
    vibe: { emoji: '🤗', title: 'Tight-Knit Community', desc: 'Small community with eating clubs tradition' },
    feature: { emoji: '🧡', title: 'Undergraduate Focus', desc: 'Rare emphasis on undergrads with senior thesis requirement' }
  },
  'Columbia University': {
    programs: { emoji: '📰', title: 'Media & Business Hub', desc: 'World-famous Journalism, Business, Medicine programs' },
    vibe: { emoji: '🗽', title: 'Urban Energy', desc: 'Dynamic Manhattan campus with diverse perspectives' },
    feature: { emoji: '🌆', title: 'NYC Advantage', desc: 'Unmatched internships in the heart of New York City' }
  },
  'University of Pennsylvania': {
    programs: { emoji: '💼', title: 'Wharton Business', desc: 'Prestigious Wharton School plus strong Medicine, Engineering' },
    vibe: { emoji: '🎉', title: 'Work Hard, Play Hard', desc: 'Pre-professional atmosphere with vibrant social life' },
    feature: { emoji: '🏆', title: 'Wharton Prestige', desc: 'Unparalleled business network and Wall Street connections' }
  },
  'Dartmouth College': {
    programs: { emoji: '🏔️', title: 'Liberal Arts Strong', desc: 'Outstanding Liberal Arts, Business, Medicine programs' },
    vibe: { emoji: '⛷️', title: 'Outdoor Adventure', desc: 'Tight community with outdoor culture and Greek life' },
    feature: { emoji: '📅', title: 'Quarter System', desc: 'Flexible D-Plan allowing unique internship opportunities' }
  },
  'Brown University': {
    programs: { emoji: '🎨', title: 'Creative Freedom', desc: 'Liberal Arts, Medicine, International Relations' },
    vibe: { emoji: '💭', title: 'Independent Thinking', desc: 'Progressive atmosphere encouraging intellectual exploration' },
    feature: { emoji: '📖', title: 'Open Curriculum', desc: 'Complete academic freedom without distribution requirements' }
  },
  'Cornell University': {
    programs: { emoji: '🌾', title: 'Diverse Excellence', desc: 'Strong Engineering, Agriculture, Veterinary Medicine' },
    vibe: { emoji: '🔬', title: 'Research Intensive', desc: 'Collaborative research across diverse academic fields' },
    feature: { emoji: '🤝', title: 'Ivy Accessibility', desc: 'Most accessible Ivy with diverse student body' }
  },

  // Top Private Universities
  'California Institute of Technology': {
    programs: { emoji: '🧪', title: 'STEM Excellence', desc: 'Elite Engineering, Physics, and Computer Science programs' },
    vibe: { emoji: '🔭', title: 'Research Focus', desc: 'Small, brilliant community of future scientists' },
    feature: { emoji: '🥇', title: 'Nobel Legacy', desc: 'Highest concentration of Nobel laureates among alumni' }
  },
  'Massachusetts Institute of Technology': {
    programs: { emoji: '🤖', title: 'Tech Innovation', desc: 'Leading Engineering, CS, and Technology programs' },
    vibe: { emoji: '⚙️', title: 'Maker Culture', desc: 'Hands-on problem solving and innovation focus' },
    feature: { emoji: '🚀', title: 'Innovation Hub', desc: 'Birthplace of countless tech breakthroughs' }
  },
  'Stanford University': {
    programs: { emoji: '💻', title: 'Silicon Valley Gateway', desc: 'Top CS, Engineering, Business programs' },
    vibe: { emoji: '🌴', title: 'California Innovation', desc: 'Entrepreneurial spirit with perfect weather' },
    feature: { emoji: '🦄', title: 'Startup Culture', desc: 'Highest concentration of unicorn startup founders' }
  },
  'Duke University': {
    programs: { emoji: '🏥', title: 'Medicine & Business', desc: 'Top-tier Medicine, Engineering, Business programs' },
    vibe: { emoji: '🏀', title: 'Blue Devil Pride', desc: 'Strong school spirit with championship basketball culture' },
    feature: { emoji: '🌳', title: 'Gothic Campus', desc: 'Beautiful Gothic architecture with Southern charm' }
  },
  'Johns Hopkins University': {
    programs: { emoji: '⚕️', title: 'Medical Powerhouse', desc: 'World-leading Medicine, Public Health, Research programs' },
    vibe: { emoji: '📊', title: 'Research Culture', desc: 'Academically intense with groundbreaking discoveries' },
    feature: { emoji: '🔍', title: 'Research Opportunities', desc: 'Unmatched undergraduate research in medicine and sciences' }
  },
  'Northwestern University': {
    programs: { emoji: '🎬', title: 'Media Excellence', desc: 'Top Journalism, Theater, Engineering, Business programs' },
    vibe: { emoji: '🌊', title: 'Lakefront Campus', desc: 'Beautiful campus near Chicago with Big Ten athletics' },
    feature: { emoji: '📺', title: 'Media Connections', desc: 'Unparalleled ties to entertainment and journalism industries' }
  },
  'University of Chicago': {
    programs: { emoji: '📘', title: 'Intellectual Rigor', desc: 'Renowned Economics, Social Sciences with Nobel faculty' },
    vibe: { emoji: '🧠', title: 'Academic Intensity', desc: 'Learning for learning\'s sake is celebrated here' },
    feature: { emoji: '💡', title: 'Core Curriculum', desc: 'Comprehensive liberal arts foundation for all students' }
  },
  'Rice University': {
    programs: { emoji: '🎯', title: 'Engineering & Business', desc: 'Strong Engineering, Business, Medicine in Houston' },
    vibe: { emoji: '🏠', title: 'Residential College', desc: 'Tight-knit community with unique college system' },
    feature: { emoji: '💰', title: 'Value & Quality', desc: 'Elite education with excellent financial aid packages' }
  },
  'Vanderbilt University': {
    programs: { emoji: '🎵', title: 'Music & Medicine', desc: 'Strong Medicine, Engineering, Music in Nashville' },
    vibe: { emoji: '⭐', title: 'Southern Charm', desc: 'Beautiful campus with friendly, collaborative atmosphere' },
    feature: { emoji: '🎓', title: 'Research University', desc: 'Top research opportunities with undergraduate focus' }
  },
  'Carnegie Mellon University': {
    programs: { emoji: '🎮', title: 'Tech & Arts Fusion', desc: 'Leading CS, Engineering, Drama, and Art programs' },
    vibe: { emoji: '💾', title: 'Innovation Hub', desc: 'Tech-forward culture with artistic creativity' },
    feature: { emoji: '⚡', title: 'Industry Leadership', desc: 'Pioneering robotics, AI, and human-computer interaction' }
  },
  'Washington University in St. Louis': {
    programs: { emoji: '🩺', title: 'Pre-Med Excellence', desc: 'Outstanding Medicine, Engineering, Business programs' },
    vibe: { emoji: '🌿', title: 'Collaborative Campus', desc: 'Supportive environment with beautiful facilities' },
    feature: { emoji: '💎', title: 'Hidden Gem', desc: 'Elite education with less competitive atmosphere' }
  },
  'University of Notre Dame': {
    programs: { emoji: '⛪', title: 'Catholic Excellence', desc: 'Strong Business, Engineering with Catholic values' },
    vibe: { emoji: '🏈', title: 'Fighting Irish Spirit', desc: 'Incredible school pride and alumni loyalty' },
    feature: { emoji: '🤲', title: 'Alumni Network', desc: 'Tight-knit alumni network providing lifelong connections' }
  },
  'Georgetown University': {
    programs: { emoji: '🏦', title: 'Politics & Service', desc: 'Premier International Relations, Law, Business programs' },
    vibe: { emoji: '🇺🇸', title: 'DC Power Hub', desc: 'Political engagement and public service focus' },
    feature: { emoji: '👔', title: 'Government Pipeline', desc: 'Direct access to federal government and diplomacy' }
  },
  'Emory University': {
    programs: { emoji: '💊', title: 'Medicine & Business', desc: 'Top Medicine, Business, Liberal Arts programs' },
    vibe: { emoji: '🌸', title: 'Southern Elegance', desc: 'Beautiful campus with academic excellence in Atlanta' },
    feature: { emoji: '🔬', title: 'Medical Powerhouse', desc: 'World-renowned medical school and research facilities' }
  },

  // Top Public Universities
  'University of Michigan–Ann Arbor': {
    programs: { emoji: '🏭', title: 'Engineering Powerhouse', desc: 'Top Engineering, Business, Medicine at public price' },
    vibe: { emoji: '〽️', title: 'Wolverine Pride', desc: 'Big Ten athletics with incredible school spirit' },
    feature: { emoji: '🎖️', title: 'Public Ivy Value', desc: 'Elite education with in-state tuition advantage' }
  },
  'University of California, Berkeley': {
    programs: { emoji: '🌉', title: 'Research Giant', desc: 'World-class Engineering, CS, Business programs' },
    vibe: { emoji: '✊', title: 'Activist Culture', desc: 'Progressive campus with history of social movements' },
    feature: { emoji: '🏅', title: 'Nobel Factory', desc: 'Most Nobel laureates of any public university' }
  },
  'University of California, Los Angeles': {
    programs: { emoji: '🎪', title: 'Entertainment & Medicine', desc: 'Top Film, Medicine, Engineering programs' },
    vibe: { emoji: '🐻', title: 'Bruin Pride', desc: 'Pac-12 athletics with Hollywood glamour' },
    feature: { emoji: '🌴', title: 'Perfect Weather', desc: 'Beautiful campus with year-round sunshine' }
  },
  'University of Virginia': {
    programs: { emoji: '🗳️', title: 'Liberal Arts Excellence', desc: 'Strong Business, Law, Liberal Arts with honor code' },
    vibe: { emoji: '🎩', title: 'Gentleman Scholars', desc: 'Thomas Jefferson\'s vision of academic honor' },
    feature: { emoji: '📜', title: 'Honor System', desc: 'Student-run honor system fostering trust and integrity' }
  },
  'University of North Carolina–Chapel Hill': {
    programs: { emoji: '🏀', title: 'Liberal Arts & Sports', desc: 'Strong Liberal Arts, Business, Medicine programs' },
    vibe: { emoji: '💙', title: 'Tar Heel Pride', desc: 'ACC basketball culture with Southern charm' },
    feature: { emoji: '🌳', title: 'Beautiful Campus', desc: 'Historic campus known for its natural beauty' }
  },
  'University of Southern California': {
    programs: { emoji: '🎞️', title: 'Film & Engineering', desc: 'Top Film School, Engineering, Business programs' },
    vibe: { emoji: '✌️', title: 'Trojan Family', desc: 'Strong alumni network with LA entertainment connections' },
    feature: { emoji: '🌟', title: 'Hollywood Pipeline', desc: 'Direct access to entertainment industry careers' }
  },
  'University of California, San Diego': {
    programs: { emoji: '🧬', title: 'Research Excellence', desc: 'Top STEM, Medicine, Engineering programs' },
    vibe: { emoji: '🏄', title: 'Surf & Science', desc: 'Academic rigor with perfect San Diego weather' },
    feature: { emoji: '🧫', title: 'Research Innovation', desc: 'Cutting-edge research facilities and biotech ties' }
  },
  'University of Florida': {
    programs: { emoji: '🐊', title: 'Comprehensive Excellence', desc: 'Strong programs across all disciplines' },
    vibe: { emoji: '🧡', title: 'Gator Nation', desc: 'SEC athletics with passionate school spirit' },
    feature: { emoji: '☀️', title: 'Sunshine State', desc: 'Year-round warm weather and beautiful campus' }
  },
  'Georgia Institute of Technology': {
    programs: { emoji: '🔧', title: 'Engineering Excellence', desc: 'Premier Engineering, CS, Business programs' },
    vibe: { emoji: '🐝', title: 'Yellow Jacket Pride', desc: 'Tech-focused culture with ACC athletics' },
    feature: { emoji: '🏗️', title: 'Industry Connections', desc: 'Strong ties to Atlanta\'s tech and business sectors' }
  },
  'University of Texas at Austin': {
    programs: { emoji: '🤘', title: 'Hook \'em Horns', desc: 'Strong Engineering, Business, Liberal Arts programs' },
    vibe: { emoji: '🎸', title: 'Keep Austin Weird', desc: 'Vibrant music scene with Texas pride' },
    feature: { emoji: '🏈', title: 'Longhorn Tradition', desc: 'Big 12 football with massive alumni network' }
  },

  // Additional Top Universities
  'Tufts University': {
    programs: { emoji: '🌍', title: 'Global Focus', desc: 'Strong International Relations, Medicine, Liberal Arts' },
    vibe: { emoji: '🐘', title: 'Jumbo Pride', desc: 'Close-knit community with global perspective' },
    feature: { emoji: '🌐', title: 'International Programs', desc: 'Leading study abroad and international focus' }
  },
  'Boston University': {
    programs: { emoji: '🏙️', title: 'Urban Excellence', desc: 'Strong Medicine, Communications, Business programs' },
    vibe: { emoji: '🔴', title: 'Terrier Pride', desc: 'Dynamic urban campus with hockey traditions' },
    feature: { emoji: '🎯', title: 'Boston Advantage', desc: 'Access to world-class internships and culture' }
  },
  'New York University': {
    programs: { emoji: '🗽', title: 'Arts & Business', desc: 'Strong Film, Business, Medicine in NYC' },
    vibe: { emoji: '🎭', title: 'City Integration', desc: 'Campus integrated into Greenwich Village culture' },
    feature: { emoji: '🗽', title: 'NYC Opportunities', desc: 'Unlimited internships and cultural experiences' }
  },
  'University of California, Santa Barbara': {
    programs: { emoji: '🌊', title: 'Research by the Sea', desc: 'Strong Engineering, Sciences, Liberal Arts' },
    vibe: { emoji: '🏖️', title: 'Beach Campus Life', desc: 'Academic excellence with California beach culture' },
    feature: { emoji: '🏄‍♂️', title: 'Perfect Balance', desc: 'Top academics with incredible quality of life' }
  },

  // Strong State Universities
  'University of California, Davis': {
    programs: { emoji: '🌾', title: 'Agricultural Innovation', desc: 'Top Veterinary, Agriculture, Engineering programs' },
    vibe: { emoji: '🚲', title: 'Bike-Friendly Campus', desc: 'Sustainable living with strong community spirit' },
    feature: { emoji: '🥗', title: 'Farm-to-Fork', desc: 'Leading sustainability and environmental programs' }
  },
  'University of California, Irvine': {
    programs: { emoji: '🏥', title: 'Health Sciences', desc: 'Strong Medicine, Engineering, Computer Science' },
    vibe: { emoji: '🌺', title: 'Diverse Community', desc: 'Inclusive campus with strong Asian-American presence' },
    feature: { emoji: '🎓', title: 'Rising Star', desc: 'Rapidly climbing in national rankings' }
  },
  'University of Illinois Urbana-Champaign': {
    programs: { emoji: '🌽', title: 'Engineering Excellence', desc: 'World-class Engineering, CS, Business programs' },
    vibe: { emoji: '🏛️', title: 'Fighting Illini', desc: 'Big Ten athletics with strong engineering culture' },
    feature: { emoji: '💻', title: 'Tech Innovation', desc: 'Birthplace of many tech innovations and companies' }
  },
  'Boston College': {
    programs: { emoji: '⛪', title: 'Jesuit Excellence', desc: 'Strong Liberal Arts, Business, Medicine with Catholic values' },
    vibe: { emoji: '🦅', title: 'Eagle Pride', desc: 'ACC athletics with strong academic tradition' },
    feature: { emoji: '🏛️', title: 'Gothic Beauty', desc: 'Stunning Gothic Revival campus architecture' }
  },
  'University of Wisconsin-Madison': {
    programs: { emoji: '🧀', title: 'Research Power', desc: 'Strong Engineering, Business, Medicine programs' },
    vibe: { emoji: '🏈', title: 'Badger Pride', desc: 'Big Ten athletics with vibrant campus life' },
    feature: { emoji: '🍺', title: 'Campus Culture', desc: 'Legendary campus life and school spirit' }
  },
  'Ohio State University': {
    programs: { emoji: '🌰', title: 'Buckeye Excellence', desc: 'Comprehensive programs with strong athletics' },
    vibe: { emoji: '🔴', title: 'Buckeye Nation', desc: 'Massive alumni network and school pride' },
    feature: { emoji: '🏟️', title: 'The Shoe', desc: 'Iconic Ohio Stadium and college football tradition' }
  },
  'Rutgers University': {
    programs: { emoji: '🎯', title: 'Public Research', desc: 'Strong Engineering, Medicine, Business programs' },
    vibe: { emoji: '🔴', title: 'Scarlet Knights', desc: 'Big Ten athletics with diverse student body' },
    feature: { emoji: '📚', title: 'Historic Legacy', desc: 'Founded in 1766, rich colonial history' }
  },
  'University of Maryland': {
    programs: { emoji: '🐢', title: 'Terp Excellence', desc: 'Strong Engineering, Computer Science, Business' },
    vibe: { emoji: '🔴', title: 'Terrapin Pride', desc: 'Big Ten athletics near Washington DC' },
    feature: { emoji: '🏛️', title: 'DC Proximity', desc: 'Access to federal government and research opportunities' }
  },
  'University of Rochester': {
    programs: { emoji: '🎵', title: 'Music & Medicine', desc: 'Renowned Eastman School of Music, strong STEM' },
    vibe: { emoji: '🌻', title: 'Yellowjacket Pride', desc: 'Close-knit community with academic excellence' },
    feature: { emoji: '🏥', title: 'Medical Innovation', desc: 'World-class medical center and research' }
  },
  'Lehigh University': {
    programs: { emoji: '🏭', title: 'Engineering Excellence', desc: 'Strong Engineering, Business programs' },
    vibe: { emoji: '⛰️', title: 'Mountain Hawks', desc: 'Beautiful mountain campus with strong traditions' },
    feature: { emoji: '🤝', title: 'Industry Ties', desc: 'Strong connections to business and industry' }
  },
  'Purdue University': {
    programs: { emoji: '🚀', title: 'Boilermaker Engineering', desc: 'Top Engineering, Aviation, Agriculture programs' },
    vibe: { emoji: '🔧', title: 'Boilermaker Pride', desc: 'Strong engineering culture and traditions' },
    feature: { emoji: '🌙', title: 'Space Program', desc: 'Most astronauts of any university' }
  },
  'University of Georgia': {
    programs: { emoji: '🍑', title: 'Peach State Excellence', desc: 'Strong programs across multiple disciplines' },
    vibe: { emoji: '🐕', title: 'Bulldog Nation', desc: 'SEC athletics with Southern charm' },
    feature: { emoji: '🏛️', title: 'Classic Campus', desc: 'Beautiful historic campus with strong traditions' }
  },
  'University of Washington': {
    programs: { emoji: '🌲', title: 'Pacific Northwest Research', desc: 'Strong Engineering, Medicine, Computer Science' },
    vibe: { emoji: '🐺', title: 'Husky Pride', desc: 'Pac-12 athletics with stunning campus views' },
    feature: { emoji: '🏔️', title: 'Mountain Views', desc: 'Breathtaking campus with Mt. Rainier backdrop' }
  },
  'Wake Forest University': {
    programs: { emoji: '🎓', title: 'Medicine & Business', desc: 'Strong Medical, Business, Liberal Arts programs' },
    vibe: { emoji: '🐅', title: 'Demon Deacon Pride', desc: 'ACC athletics with Southern gentility' },
    feature: { emoji: '🎩', title: 'Elite Atmosphere', desc: 'Small classes with elite liberal arts education' }
  },
  'Case Western Reserve University': {
    programs: { emoji: '🔬', title: 'STEM Excellence', desc: 'Strong Engineering, Medicine, Research programs' },
    vibe: { emoji: '🏛️', title: 'Spartan Pride', desc: 'Rigorous academics with collaborative culture' },
    feature: { emoji: '💡', title: 'Innovation Hub', desc: 'Leading research and innovation in Cleveland' }
  },
  'Texas A&M University': {
    programs: { emoji: '🐎', title: 'Aggie Excellence', desc: 'Strong Engineering, Agriculture, Business programs' },
    vibe: { emoji: '👍', title: 'Aggie Pride', desc: 'SEC athletics with legendary school spirit' },
    feature: { emoji: '🎖️', title: 'Military Tradition', desc: 'Strong Corps of Cadets and military heritage' }
  },
  'Virginia Tech': {
    programs: { emoji: '🏗️', title: 'Hokie Engineering', desc: 'Top Engineering, Architecture, Agriculture programs' },
    vibe: { emoji: '🦃', title: 'Hokie Pride', desc: 'Strong school spirit and campus traditions' },
    feature: { emoji: '⛰️', title: 'Mountain Campus', desc: 'Beautiful Blue Ridge Mountain setting' }
  },
  'Florida State University': {
    programs: { emoji: '🎭', title: 'Seminole Excellence', desc: 'Strong programs across multiple disciplines' },
    vibe: { emoji: '🏈', title: 'Seminole Pride', desc: 'ACC athletics with passionate fanbase' },
    feature: { emoji: '🌴', title: 'Tallahassee Life', desc: 'Vibrant college town atmosphere' }
  },
  'Northeastern University': {
    programs: { emoji: '🏢', title: 'Co-op Excellence', desc: 'Strong programs with industry experience' },
    vibe: { emoji: '🐺', title: 'Husky Pride', desc: 'Urban campus with experiential learning' },
    feature: { emoji: '💼', title: 'Career Focus', desc: 'Unmatched co-op program and job placement' }
  },
  'University of Minnesota Twin Cities': {
    programs: { emoji: '❄️', title: 'Big Ten Research', desc: 'Strong Engineering, Medicine, Liberal Arts' },
    vibe: { emoji: '🐿️', title: 'Gopher Pride', desc: 'Big Ten athletics with twin cities culture' },
    feature: { emoji: '🌉', title: 'Twin Cities', desc: 'Access to Minneapolis-St. Paul opportunities' }
  },
  'College of William & Mary': {
    programs: { emoji: '📜', title: 'Colonial Excellence', desc: 'Strong Liberal Arts, Law, Business programs' },
    vibe: { emoji: '👑', title: 'Tribe Pride', desc: 'Historic campus with academic excellence' },
    feature: { emoji: '🏛️', title: 'Historic Legacy', desc: 'Second oldest college in America, rich history' }
  },
  'North Carolina State University': {
    programs: { emoji: '🌲', title: 'Wolfpack Engineering', desc: 'Strong Engineering, Agriculture, Design programs' },
    vibe: { emoji: '🐺', title: 'Wolfpack Pride', desc: 'ACC athletics with engineering culture' },
    feature: { emoji: '🏭', title: 'Industry Partnership', desc: 'Strong ties to Research Triangle Park' }
  },
  'Stony Brook University (SUNY)': {
    programs: { emoji: '🏥', title: 'SUNY Excellence', desc: 'Strong Medicine, Engineering, Research programs' },
    vibe: { emoji: '🐺', title: 'Seawolf Pride', desc: 'Diverse campus with strong research focus' },
    feature: { emoji: '🔬', title: 'Research Innovation', desc: 'Leading research university in SUNY system' }
  },
  'University of California, Merced': {
    programs: { emoji: '🏞️', title: 'Valley Innovation', desc: 'Growing Engineering, Natural Sciences programs' },
    vibe: { emoji: '🐾', title: 'Bobcat Pride', desc: 'Newest UC with innovative spirit' },
    feature: { emoji: '🌱', title: 'Sustainability Focus', desc: 'Eco-friendly campus with green initiatives' }
  },
  'University of Massachusetts Amherst': {
    programs: { emoji: '🍂', title: 'Minuteman Excellence', desc: 'Strong Engineering, Business, Liberal Arts' },
    vibe: { emoji: '🦆', title: 'Minuteman Pride', desc: 'New England campus with strong traditions' },
    feature: { emoji: '🏫', title: 'Five College', desc: 'Access to five-college consortium resources' }
  },
  'Villanova University': {
    programs: { emoji: '⛪', title: 'Catholic Excellence', desc: 'Strong Business, Engineering, Liberal Arts' },
    vibe: { emoji: '🏀', title: 'Wildcat Pride', desc: 'Big East basketball with Catholic values' },
    feature: { emoji: '🏆', title: 'Championship Culture', desc: 'Recent NCAA basketball champions' }
  },
  'Brandeis University': {
    programs: { emoji: '🕊️', title: 'Social Justice', desc: 'Strong Liberal Arts, Sciences, Social Work' },
    vibe: { emoji: '⚖️', title: 'Judge Pride', desc: 'Jewish-sponsored, non-sectarian excellence' },
    feature: { emoji: '🌟', title: 'Rising Excellence', desc: 'Young university with rapid academic growth' }
  },
  'George Washington University': {
    programs: { emoji: '🏛️', title: 'DC Excellence', desc: 'Strong Political Science, International Affairs, Business' },
    vibe: { emoji: '🇺🇸', title: 'Colonial Pride', desc: 'Urban campus in heart of Washington DC' },
    feature: { emoji: '🎯', title: 'Political Hub', desc: 'Direct access to government and policy careers' }
  },
  'Michigan State University': {
    programs: { emoji: '🌱', title: 'Spartan Excellence', desc: 'Strong Agriculture, Engineering, Education programs' },
    vibe: { emoji: '💚', title: 'Spartan Pride', desc: 'Big Ten athletics with strong traditions' },
    feature: { emoji: '🏆', title: 'Athletic Legacy', desc: 'Championship athletics and school spirit' }
  },
  'The Pennsylvania State University–University Park': {
    programs: { emoji: '🦁', title: 'Nittany Lion Excellence', desc: 'Strong Engineering, Business, Liberal Arts' },
    vibe: { emoji: '🏈', title: 'We Are Penn State', desc: 'Big Ten athletics with legendary pride' },
    feature: { emoji: '🏟️', title: 'Beaver Stadium', desc: 'Iconic football stadium and traditions' }
  },
  'Santa Clara University': {
    programs: { emoji: '🌴', title: 'Silicon Valley Access', desc: 'Strong Engineering, Business programs' },
    vibe: { emoji: '⛪', title: 'Bronco Pride', desc: 'Jesuit values with tech innovation' },
    feature: { emoji: '💻', title: 'Tech Pipeline', desc: 'Direct access to Silicon Valley careers' }
  },
  'Tulane University of Louisiana': {
    programs: { emoji: '🎷', title: 'New Orleans Culture', desc: 'Strong Liberal Arts, Business, Medicine' },
    vibe: { emoji: '💚', title: 'Green Wave Pride', desc: 'Vibrant campus life in New Orleans' },
    feature: { emoji: '🎭', title: 'Cultural Hub', desc: 'Rich cultural heritage and music scene' }
  },
  'University of Miami': {
    programs: { emoji: '🏥', title: 'Hurricane Excellence', desc: 'Strong Medicine, Business, Communications' },
    vibe: { emoji: '🌴', title: 'Hurricane Pride', desc: 'ACC athletics with Miami lifestyle' },
    feature: { emoji: '🏖️', title: 'Paradise Campus', desc: 'Beautiful campus with perfect weather' }
  },
  'Rensselaer Polytechnic Institute': {
    programs: { emoji: '⚙️', title: 'Engineering Innovation', desc: 'Elite Engineering, Computer Science, Architecture' },
    vibe: { emoji: '🔧', title: 'Engineer Pride', desc: 'Tech-focused culture with innovation' },
    feature: { emoji: '🏭', title: 'Industry Leaders', desc: 'Alumni lead major tech and engineering companies' }
  },
  'University of Connecticut': {
    programs: { emoji: '🐺', title: 'Husky Excellence', desc: 'Strong Engineering, Business, Liberal Arts' },
    vibe: { emoji: '🏀', title: 'Husky Pride', desc: 'Big East basketball with academic excellence' },
    feature: { emoji: '🏆', title: 'Championship Legacy', desc: 'Multiple NCAA basketball championships' }
  },
  'University of Pittsburgh': {
    programs: { emoji: '🏥', title: 'Panther Excellence', desc: 'Strong Medicine, Engineering, Liberal Arts' },
    vibe: { emoji: '💛', title: 'Panther Pride', desc: 'ACC athletics with urban campus' },
    feature: { emoji: '🏛️', title: 'Cathedral Learning', desc: 'Iconic Gothic Revival architecture' }
  },
  'Binghamton University (SUNY)': {
    programs: { emoji: '🐻', title: 'Bearcat Excellence', desc: 'Strong Liberal Arts, Engineering, Business' },
    vibe: { emoji: '🌲', title: 'Bearcat Pride', desc: 'Beautiful campus with academic rigor' },
    feature: { emoji: '💎', title: 'Public Ivy', desc: 'Elite education at public university price' }
  },
  'Indiana University–Bloomington': {
    programs: { emoji: '🎵', title: 'Hoosier Excellence', desc: 'Strong Music, Business, Liberal Arts programs' },
    vibe: { emoji: '🏀', title: 'Hoosier Pride', desc: 'Big Ten athletics with strong traditions' },
    feature: { emoji: '🎭', title: 'Arts Culture', desc: 'Renowned Jacobs School of Music' }
  },
  'Syracuse University': {
    programs: { emoji: '📺', title: 'Orange Excellence', desc: 'Strong Communications, Engineering, Liberal Arts' },
    vibe: { emoji: '🍊', title: 'Orange Pride', desc: 'ACC athletics with strong school spirit' },
    feature: { emoji: '❄️', title: 'Winter Warriors', desc: 'Vibrant campus life despite cold winters' }
  },
  'Colorado School of Mines': {
    programs: { emoji: '⛏️', title: 'Mining Excellence', desc: 'Elite Engineering, Earth Sciences programs' },
    vibe: { emoji: '🏔️', title: 'Oredigger Pride', desc: 'Mountain campus with outdoor culture' },
    feature: { emoji: '💎', title: 'Specialized Focus', desc: 'Unique specialization in mining and materials' }
  },
  'Stevens Institute of Technology': {
    programs: { emoji: '🏗️', title: 'Tech Innovation', desc: 'Strong Engineering, Computer Science, Business' },
    vibe: { emoji: '🦆', title: 'Duck Pride', desc: 'Small tech-focused community' },
    feature: { emoji: '🗽', title: 'NYC Access', desc: 'Close proximity to New York City opportunities' }
  },
  'University at Buffalo (SUNY)': {
    programs: { emoji: '🦬', title: 'Bull Excellence', desc: 'Strong Engineering, Medicine, Liberal Arts' },
    vibe: { emoji: '❄️', title: 'Bull Pride', desc: 'Cold winters but warm community spirit' },
    feature: { emoji: '🌊', title: 'Great Lakes', desc: 'Access to Great Lakes region opportunities' }
  },
  'University of California, Riverside': {
    programs: { emoji: '🌵', title: 'Highlander Excellence', desc: 'Growing Engineering, Business, Liberal Arts' },
    vibe: { emoji: '🏔️', title: 'Highlander Pride', desc: 'Diverse campus with strong growth' },
    feature: { emoji: '🌱', title: 'Emerging UC', desc: 'Rapidly rising UC campus with new opportunities' }
  },
  'Pepperdine University': {
    programs: { emoji: '🌊', title: 'Wave Excellence', desc: 'Strong Business, Liberal Arts, Law programs' },
    vibe: { emoji: '🏖️', title: 'Wave Pride', desc: 'Christian values with Malibu beauty' },
    feature: { emoji: '🏄‍♂️', title: 'Beach Campus', desc: 'Stunning oceanfront campus in Malibu' }
  },
  'Rutgers University–Newark': {
    programs: { emoji: '🏙️', title: 'Urban Excellence', desc: 'Strong programs with urban focus' },
    vibe: { emoji: '🔴', title: 'Scarlet Raider Pride', desc: 'Diverse urban campus community' },
    feature: { emoji: '🚄', title: 'NYC Access', desc: 'Easy access to New York City opportunities' }
  },
  'University of Illinois Chicago': {
    programs: { emoji: '🏥', title: 'Flame Excellence', desc: 'Strong Medicine, Engineering, Liberal Arts' },
    vibe: { emoji: '🔥', title: 'Flame Pride', desc: 'Urban campus with diverse community' },
    feature: { emoji: '🌆', title: 'Chicago Access', desc: 'Direct access to Chicago opportunities' }
  },
  'New Jersey Institute of Technology': {
    programs: { emoji: '🏭', title: 'Tech Excellence', desc: 'Strong Engineering, Computer Science, Architecture' },
    vibe: { emoji: '🏀', title: 'Highlander Pride', desc: 'Tech-focused community with athletics' },
    feature: { emoji: '🗽', title: 'NYC Pipeline', desc: 'Strong placement in New York tech industry' }
  },
  'University of California, Santa Cruz': {
    programs: { emoji: '🌲', title: 'Banana Slug Excellence', desc: 'Strong Liberal Arts, Sciences, Engineering' },
    vibe: { emoji: '🍌', title: 'Slug Pride', desc: 'Unique campus culture with forest setting' },
    feature: { emoji: '🌊', title: 'Redwood Beauty', desc: 'Stunning redwood forest campus near ocean' }
  },
  'Drexel University': {
    programs: { emoji: '🐉', title: 'Dragon Excellence', desc: 'Strong Engineering, Business, Medicine' },
    vibe: { emoji: '🏙️', title: 'Dragon Pride', desc: 'Urban campus with co-op focus' },
    feature: { emoji: '💼', title: 'Co-op Leaders', desc: 'Pioneer in cooperative education programs' }
  },
  'Howard University': {
    programs: { emoji: '📚', title: 'HBCU Excellence', desc: 'Strong Liberal Arts, Medicine, Law programs' },
    vibe: { emoji: '🦬', title: 'Bison Pride', desc: 'Historically Black university with rich traditions' },
    feature: { emoji: '✊', title: 'Cultural Impact', desc: 'Leading HBCU with significant cultural influence' }
  },
  'Marquette University': {
    programs: { emoji: '⛪', title: 'Jesuit Excellence', desc: 'Strong Liberal Arts, Business, Engineering' },
    vibe: { emoji: '🦅', title: 'Golden Eagle Pride', desc: 'Catholic values with Big East athletics' },
    feature: { emoji: '❄️', title: 'Milwaukee Spirit', desc: 'Strong community engagement in Milwaukee' }
  },
  'University of Delaware': {
    programs: { emoji: '🐓', title: 'Blue Hen Excellence', desc: 'Strong Engineering, Business, Liberal Arts' },
    vibe: { emoji: '💙', title: 'Blue Hen Pride', desc: 'Strong school spirit and traditions' },
    feature: { emoji: '🏛️', title: 'Colonial Heritage', desc: 'Historic campus with colonial architecture' }
  },
  'Auburn University': {
    programs: { emoji: '🐅', title: 'Tiger Excellence', desc: 'Strong Engineering, Agriculture, Business' },
    vibe: { emoji: '🧡', title: 'War Eagle Pride', desc: 'SEC athletics with Southern charm' },
    feature: { emoji: '🏈', title: 'Iron Bowl', desc: 'Legendary football rivalry and traditions' }
  },
  'Illinois Institute of Technology': {
    programs: { emoji: '🏭', title: 'Tech Excellence', desc: 'Strong Engineering, Computer Science, Architecture' },
    vibe: { emoji: '🔧', title: 'Scarlet Hawk Pride', desc: 'Tech-focused community in Chicago' },
    feature: { emoji: '🌆', title: 'Chicago Tech', desc: 'Strong connections to Chicago tech industry' }
  },
  'Saint Louis University': {
    programs: { emoji: '⛪', title: 'Jesuit Excellence', desc: 'Strong Medicine, Business, Liberal Arts' },
    vibe: { emoji: '💙', title: 'Billiken Pride', desc: 'Catholic values with strong community' },
    feature: { emoji: '🏥', title: 'Medical Excellence', desc: 'Renowned medical school and hospital' }
  },
  'Texas Christian University': {
    programs: { emoji: '🐸', title: 'Horned Frog Excellence', desc: 'Strong Business, Liberal Arts, Fine Arts' },
    vibe: { emoji: '💜', title: 'Horned Frog Pride', desc: 'Christian values with Big 12 athletics' },
    feature: { emoji: '🤝', title: 'Close Community', desc: 'Small class sizes with personal attention' }
  },
  'Brigham Young University': {
    programs: { emoji: '⛰️', title: 'Cougar Excellence', desc: 'Strong Engineering, Business, Liberal Arts' },
    vibe: { emoji: '💙', title: 'Cougar Pride', desc: 'LDS values with strong academics' },
    feature: { emoji: '🏔️', title: 'Mountain Campus', desc: 'Beautiful campus with mountain backdrop' }
  },
  'California State University–Long Beach': {
    programs: { emoji: '🏖️', title: 'Beach Excellence', desc: 'Strong programs with coastal location' },
    vibe: { emoji: '🏄‍♂️', title: 'Beach Pride', desc: 'Diverse campus with beach culture' },
    feature: { emoji: '🌊', title: 'Coastal Access', desc: 'Beautiful campus near Pacific Ocean' }
  },
  'George Mason University': {
    programs: { emoji: '🏛️', title: 'Patriot Excellence', desc: 'Strong programs with DC area access' },
    vibe: { emoji: '🇺🇸', title: 'Patriot Pride', desc: 'Diverse campus near Washington DC' },
    feature: { emoji: '🎯', title: 'DC Advantage', desc: 'Access to federal government and research' }
  },
  'San Diego State University': {
    programs: { emoji: '🏖️', title: 'Aztec Excellence', desc: 'Strong programs with California lifestyle' },
    vibe: { emoji: '⚡', title: 'Aztec Pride', desc: 'Mountain West athletics with beach access' },
    feature: { emoji: '🌴', title: 'Perfect Weather', desc: 'Year-round sunshine and outdoor activities' }
  },
  'University of Arizona': {
    programs: { emoji: '🌵', title: 'Wildcat Excellence', desc: 'Strong programs with desert innovation' },
    vibe: { emoji: '🔴', title: 'Bear Down Pride', desc: 'Pac-12 athletics with Arizona spirit' },
    feature: { emoji: '☀️', title: 'Desert Campus', desc: 'Sunny weather and unique desert setting' }
  },
  'University of Missouri': {
    programs: { emoji: '🐅', title: 'Tiger Excellence', desc: 'Strong Journalism, Engineering, Medicine' },
    vibe: { emoji: '💛', title: 'Mizzou Pride', desc: 'SEC athletics with strong traditions' },
    feature: { emoji: '📰', title: 'Journalism Legacy', desc: 'First journalism school in the world' }
  },
  'University of New Hampshire': {
    programs: { emoji: '🏔️', title: 'Wildcat Excellence', desc: 'Strong Liberal Arts, Engineering, Business' },
    vibe: { emoji: '💙', title: 'Wildcat Pride', desc: 'New England campus with outdoor culture' },
    feature: { emoji: '🍂', title: 'Four Seasons', desc: 'Beautiful campus through all seasons' }
  },
  'University of Oregon': {
    programs: { emoji: '🦆', title: 'Duck Excellence', desc: 'Strong Liberal Arts, Business, Journalism' },
    vibe: { emoji: '💚', title: 'Duck Pride', desc: 'Pac-12 athletics with Pacific Northwest culture' },
    feature: { emoji: '🏃‍♂️', title: 'Track Legacy', desc: 'Legendary track and field program' }
  },
  'University of San Diego': {
    programs: { emoji: '🏖️', title: 'Torero Excellence', desc: 'Strong Business, Liberal Arts with Catholic values' },
    vibe: { emoji: '💙', title: 'Torero Pride', desc: 'Beautiful campus with ocean views' },
    feature: { emoji: '🌊', title: 'Ocean Campus', desc: 'Stunning hilltop campus overlooking Pacific' }
  },
  'University of San Francisco': {
    programs: { emoji: '🌉', title: 'Don Excellence', desc: 'Strong Business, Liberal Arts with Jesuit values' },
    vibe: { emoji: '💚', title: 'Don Pride', desc: 'Urban campus with Catholic tradition' },
    feature: { emoji: '🏙️', title: 'City Access', desc: 'Direct access to San Francisco opportunities' }
  },
  'University of Tennessee–Knoxville': {
    programs: { emoji: '🍊', title: 'Volunteer Excellence', desc: 'Strong Engineering, Business, Liberal Arts' },
    vibe: { emoji: '🧡', title: 'Vol Pride', desc: 'SEC athletics with Tennessee spirit' },
    feature: { emoji: '⛰️', title: 'Smoky Mountains', desc: 'Beautiful campus near Great Smoky Mountains' }
  },
  'The University of Texas–Dallas': {
    programs: { emoji: '🎯', title: 'Comet Excellence', desc: 'Strong Engineering, Computer Science, Business' },
    vibe: { emoji: '🌟', title: 'Comet Pride', desc: 'Rapidly growing with innovation focus' },
    feature: { emoji: '🚀', title: 'Tech Innovation', desc: 'Strong connections to Dallas tech industry' }
  },
  'Arizona State University': {
    programs: { emoji: '🌵', title: 'Sun Devil Excellence', desc: 'Comprehensive programs with innovation focus' },
    vibe: { emoji: '😈', title: 'Sun Devil Pride', desc: 'Pac-12 athletics with desert lifestyle' },
    feature: { emoji: '🔥', title: 'Innovation Hub', desc: 'Leading innovation and entrepreneurship programs' }
  },
  'Chapman University': {
    programs: { emoji: '🎬', title: 'Panther Excellence', desc: 'Strong Film, Business, Liberal Arts programs' },
    vibe: { emoji: '🎭', title: 'Panther Pride', desc: 'Creative campus with arts focus' },
    feature: { emoji: '🌴', title: 'Orange County', desc: 'Beautiful campus in Orange County' }
  },
  'Creighton University': {
    programs: { emoji: '⛪', title: 'Bluejay Excellence', desc: 'Strong Medicine, Business with Jesuit values' },
    vibe: { emoji: '💙', title: 'Bluejay Pride', desc: 'Catholic tradition with strong community' },
    feature: { emoji: '🏥', title: 'Medical Focus', desc: 'Renowned medical and health programs' }
  },
  'CUNY—City College': {
    programs: { emoji: '🏙️', title: 'Urban Excellence', desc: 'Strong Engineering, Liberal Arts, Architecture' },
    vibe: { emoji: '🗽', title: 'Beaver Pride', desc: 'Diverse urban campus in Harlem' },
    feature: { emoji: '💰', title: 'Value Education', desc: 'Excellent education at affordable price' }
  },
  'Elon University': {
    programs: { emoji: '🌳', title: 'Phoenix Excellence', desc: 'Strong Liberal Arts, Communications, Business' },
    vibe: { emoji: '🔥', title: 'Phoenix Pride', desc: 'Beautiful campus with strong engagement' },
    feature: { emoji: '🎯', title: 'Student Success', desc: 'Exceptional student engagement and success rates' }
  },
  'Iowa State University of Science and Technology': {
    programs: { emoji: '🌽', title: 'Cyclone Excellence', desc: 'Strong Engineering, Agriculture, Veterinary Medicine' },
    vibe: { emoji: '🌪️', title: 'Cyclone Pride', desc: 'Big 12 athletics with Iowa values' },
    feature: { emoji: '🔬', title: 'Research Focus', desc: 'Leading research in agriculture and engineering' }
  },
  'University at Albany (SUNY)': {
    programs: { emoji: '🏛️', title: 'Great Dane Excellence', desc: 'Strong Liberal Arts, Business, Public Administration' },
    vibe: { emoji: '🐕', title: 'Great Dane Pride', desc: 'Diverse campus with strong traditions' },
    feature: { emoji: '🏛️', title: 'Capital Access', desc: 'Located in New York state capital' }
  },
  'University of Central Florida': {
    programs: { emoji: '⚔️', title: 'Knight Excellence', desc: 'Strong Engineering, Business, Medicine' },
    vibe: { emoji: '🏰', title: 'Knight Pride', desc: 'Large campus with strong school spirit' },
    feature: { emoji: '🎢', title: 'Orlando Access', desc: 'Near Disney World and entertainment industry' }
  },
  'University of Denver': {
    programs: { emoji: '🏔️', title: 'Pioneer Excellence', desc: 'Strong Business, Liberal Arts, Law' },
    vibe: { emoji: '🦌', title: 'Pioneer Pride', desc: 'Mountain campus with outdoor culture' },
    feature: { emoji: '⛷️', title: 'Rocky Mountains', desc: 'Beautiful campus with mountain access' }
  },
  'University of South Carolina': {
    programs: { emoji: '🐓', title: 'Gamecock Excellence', desc: 'Strong Business, Liberal Arts, Medicine' },
    vibe: { emoji: '🔴', title: 'Gamecock Pride', desc: 'SEC athletics with Southern charm' },
    feature: { emoji: '🏛️', title: 'Historic Campus', desc: 'Beautiful historic campus in Columbia' }
  },
  'University of Vermont': {
    programs: { emoji: '🍂', title: 'Catamount Excellence', desc: 'Strong Liberal Arts, Environmental Studies, Medicine' },
    vibe: { emoji: '🐱', title: 'Catamount Pride', desc: 'Vermont values with outdoor culture' },
    feature: { emoji: '🏔️', title: 'Green Mountains', desc: 'Beautiful campus in Green Mountains' }
  },
  'Clark University': {
    programs: { emoji: '🔬', title: 'Cougar Excellence', desc: 'Strong Liberal Arts, Psychology, Sciences' },
    vibe: { emoji: '🏛️', title: 'Cougar Pride', desc: 'Small liberal arts with research focus' },
    feature: { emoji: '🎓', title: 'Graduate Innovation', desc: 'Innovative graduate programs and research' }
  },
  'Fairfield University': {
    programs: { emoji: '⛪', title: 'Stag Excellence', desc: 'Strong Business, Liberal Arts with Jesuit values' },
    vibe: { emoji: '🦌', title: 'Stag Pride', desc: 'Catholic tradition with beautiful campus' },
    feature: { emoji: '🏖️', title: 'Coastal Campus', desc: 'Beautiful campus near Connecticut coast' }
  },
  'Loyola University Chicago': {
    programs: { emoji: '⛪', title: 'Rambler Excellence', desc: 'Strong Liberal Arts, Business, Medicine' },
    vibe: { emoji: '🏀', title: 'Rambler Pride', desc: 'Jesuit values with Chicago opportunities' },
    feature: { emoji: '🏙️', title: 'Chicago Access', desc: 'Urban campus with lakefront beauty' }
  },
  'The University of Oklahoma': {
    programs: { emoji: '🌪️', title: 'Sooner Excellence', desc: 'Strong Engineering, Business, Liberal Arts' },
    vibe: { emoji: '🔴', title: 'Boomer Sooner Pride', desc: 'Big 12 athletics with Oklahoma spirit' },
    feature: { emoji: '🏈', title: 'Football Tradition', desc: 'Legendary football program and traditions' }
  },
  'California State University–Fullerton': {
    programs: { emoji: '🌞', title: 'Titan Excellence', desc: 'Strong programs with diverse offerings' },
    vibe: { emoji: '🏛️', title: 'Titan Pride', desc: 'Large diverse campus community' },
    feature: { emoji: '🏖️', title: 'California Dream', desc: 'Access to beaches and California lifestyle' }
  },
  'Miami University—Oxford': {
    programs: { emoji: '🦅', title: 'RedHawk Excellence', desc: 'Strong Business, Liberal Arts, Education' },
    vibe: { emoji: '❤️', title: 'Love and Honor', desc: 'Beautiful campus with strong traditions' },
    feature: { emoji: '🏛️', title: 'Public Ivy', desc: 'Elite education with public accessibility' }
  },
  'Thomas Jefferson University': {
    programs: { emoji: '🏥', title: 'Medical Excellence', desc: 'Strong Medicine, Health Sciences, Design' },
    vibe: { emoji: '⚕️', title: 'Jefferson Pride', desc: 'Health-focused community in Philadelphia' },
    feature: { emoji: '🩺', title: 'Healthcare Innovation', desc: 'Leading innovation in healthcare education' }
  },
  'University of Alabama at Birmingham': {
    programs: { emoji: '🏥', title: 'Blazer Excellence', desc: 'Strong Medicine, Engineering, Liberal Arts' },
    vibe: { emoji: '🔥', title: 'Blazer Pride', desc: 'Urban campus with medical focus' },
    feature: { emoji: '🩺', title: 'Medical Center', desc: 'Major medical center and research hospital' }
  },
  'University of Dayton': {
    programs: { emoji: '⛪', title: 'Flyer Excellence', desc: 'Strong Engineering, Business with Catholic values' },
    vibe: { emoji: '✈️', title: 'Flyer Pride', desc: 'Catholic tradition with strong community' },
    feature: { emoji: '🏠', title: 'Neighborhood Feel', desc: 'Unique student neighborhood housing' }
  },
  'University of the Pacific': {
    programs: { emoji: '🐅', title: 'Tiger Excellence', desc: 'Strong Health Sciences, Business, Liberal Arts' },
    vibe: { emoji: '🌊', title: 'Tiger Pride', desc: 'Small university with personal attention' },
    feature: { emoji: '🏥', title: 'Health Focus', desc: 'Strong dentistry and pharmacy programs' }
  },
  'University of Utah': {
    programs: { emoji: '🏔️', title: 'Ute Excellence', desc: 'Strong Engineering, Medicine, Liberal Arts' },
    vibe: { emoji: '🔴', title: 'Ute Pride', desc: 'Pac-12 athletics with mountain culture' },
    feature: { emoji: '⛷️', title: 'Mountain Campus', desc: 'Beautiful campus with world-class skiing nearby' }
  },
  'Virginia Commonwealth University': {
    programs: { emoji: '🎨', title: 'Ram Excellence', desc: 'Strong Arts, Medicine, Liberal Arts' },
    vibe: { emoji: '🐏', title: 'Ram Pride', desc: 'Urban campus with diverse community' },
    feature: { emoji: '🏥', title: 'Medical Focus', desc: 'Major medical center and health sciences' }
  },
  'Oregon State University': {
    programs: { emoji: '🦫', title: 'Beaver Excellence', desc: 'Strong Engineering, Agriculture, Liberal Arts' },
    vibe: { emoji: '🧡', title: 'Beaver Pride', desc: 'Pac-12 athletics with Oregon spirit' },
    feature: { emoji: '🌲', title: 'Forest Campus', desc: 'Beautiful campus with Pacific Northwest nature' }
  },
  'SUNY College of Environmental Science and Forestry': {
    programs: { emoji: '🌲', title: 'Environmental Excellence', desc: 'Leading Environmental Sciences, Forestry' },
    vibe: { emoji: '🌿', title: 'Mighty Oak Pride', desc: 'Environmental focus with outdoor culture' },
    feature: { emoji: '🍃', title: 'Green Innovation', desc: 'Leading sustainability and environmental research' }
  },
  'University of Houston': {
    programs: { emoji: '🚀', title: 'Cougar Excellence', desc: 'Strong Engineering, Business, Medicine' },
    vibe: { emoji: '🐯', title: 'Cougar Pride', desc: 'Urban campus with diverse community' },
    feature: { emoji: '🛢️', title: 'Energy Hub', desc: 'Strong connections to energy industry' }
  },
  'University of Maryland, Baltimore County': {
    programs: { emoji: '🐕', title: 'Retriever Excellence', desc: 'Strong STEM, Liberal Arts, Engineering' },
    vibe: { emoji: '💛', title: 'Retriever Pride', desc: 'Research-focused campus community' },
    feature: { emoji: '🔬', title: 'Research Innovation', desc: 'Leading undergraduate research opportunities' }
  }
};

// Helper function to get emoji data for a college
export const getCollegeEmojiData = (collegeName) => {
  return collegeEmojiData[collegeName] || null;
};

// Helper function to get a single representative emoji for a college
export const getCollegeMainEmoji = (collegeName) => {
  const data = getCollegeEmojiData(collegeName);
  return data?.programs?.emoji || data?.vibe?.emoji || data?.feature?.emoji || '🎓';
}; 